"use client";
import Image from "next/image";
import { H2, H3 } from "../headers";
import { buttonVariants } from "../ui/button";
import Container from "../container";
import reserveNowImg from "@/public/images/home-images/reserveNowPattern.svg";
import logoPatternImg from "@/public/images/home-images/logoPattern.svg";
import starPatternImg from "@/public/images/home-images/starPattern.svg";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { useSpring, animated } from "@react-spring/web";
import { useIntersectionObserver } from "usehooks-ts";

const ReserveNowSection = () => {
  const t = useTranslations();

  // Hook to detect when the element is in view
  const { isIntersecting: inView, ref: ref } = useIntersectionObserver({
    threshold: 0.1, // Trigger when 10% of the element is visible
    freezeOnceVisible: true,
  });

  // Animation for the section
  const animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(100px)",
    config: { duration: 500 },
  });

  return (
    <Container
      style={{
        backgroundImage: `url(${reserveNowImg.src})`,
      }}
      className="relative my-12 md:my-16 lg:my-24 bg-green-main py-14 md:py-20 lg:py-28 flex justify-center items-center"
    >
      <Image
        src={starPatternImg}
        alt="star pattern"
        className="w-20 sm:w-40 absolute top-6 right-10"
      />
      <Image
        src={logoPatternImg}
        alt="logo pattern"
        className="w-40 sm:w-80 absolute bottom-0 left-0"
      />
      {
        //@ts-ignore
        <animated.div ref={ref} style={animation}>
          <div className="text-white text-center relative z-[1]">
            <H2 className="font-semibold">{t("reserveNow.heading")}</H2>
            <H3 className="mt-7 sm:mt-14 mb-5 sm:mb-10">
              {t("reserveNow.subheading")}
            </H3>

            <Link
              href={"/all-units"}
              className={buttonVariants({
                className:
                  "bg-white !text-green-main hover:bg-white/90 text-2xl max-sm:text-sm px-7 sm:px-14 py-4 sm:py-8",
              })}
              prefetch
            >
              {t("reserveNow.buttonText")}
            </Link>
          </div>
        </animated.div>
      }
    </Container>
  );
};

export default ReserveNowSection;
